import { ReactNode, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DefaultAvatar from '../../assets/default_avatar.png';
import { GlobalService } from 'services/global.service';
import { RootState, LoggerService } from '@umanforge/common';
import { UsersService } from 'services/users.service';


interface HomeTopBarProps {
  children?: ReactNode;
  title?: string;
}

function HomeTopBar( { children }: HomeTopBarProps ) {
  const me = useSelector( ( state: RootState ) => { return state.user.value; } );

  const dispatch = useDispatch();
  const token = useSelector( ( state: RootState ) => {return state.token.value;} );
  const logger: LoggerService = new LoggerService( 'HomeTopBar' );
  const [ avatarUrl, setAvatarUrl ] = useState<string | null>( null );

  useEffect( () => {
    let mounted = true;
    const fetchAvatar = async () => {
      try {
        if ( !me ) {
          if ( mounted ) {
            setAvatarUrl( null );
          }
          return;
        }
        const clientId = me.clients && me.clients.length > 0 ? me.clients[ 0 ].id : '';
        if ( !clientId ) {
          if ( mounted ) {
            setAvatarUrl( null );
          }
          return;
        }
        const url = await UsersService.getUserAvatar( me.id, clientId, token, dispatch );
        const finalUrl = url && url.startsWith( '/' ) ? `${window.location.origin}${url}` : url;
        if ( mounted ) {
          setAvatarUrl( finalUrl );
        }
      } catch ( er ) {
        logger.error( 'Error fetching avatar url', er as Error );
        if ( mounted ) {
          setAvatarUrl( null );
        }
      }
    };

    fetchAvatar();

    return () => {
      mounted = false;
    };
  }, [ me, token, dispatch ] );

  return (
    <div className="flex-center py-3 px-0 md:px-10">
      <div className="flex items-center w-full">
        <hr className="min-w-[50px] h-1 border-none bg-orange-base w-10 rounded-full" />
        {children && (
          <div className="ml-1 flex items-center font-comfortaa text-5xl">{children}</div>
        )}
        <hr className="min-w-[50px] h-1 border-none bg-orange-base flex-grow rounded-l-full" />
        {me ? (
          <div className="border-4 border-orange-base border-r-0 rounded-l-full">
            <div
              className="flex p-2 gap-2 max-w-[350px] min-w-[200px] items-center cursor-pointer"
              onClick={async () => {
                const url = await GlobalService.buildPlatformUrl( `Users/${me.id}` );
                window.location.href = `${url}`;
              }}
            >
              <img
                src={avatarUrl ?? DefaultAvatar}
                draggable="false"
                className="w-14 h-14 rounded-full flex justify-center items-center p-1 select-none"
                alt={me.fullname}
              />
              <span className='text-ellipsis overflow-hidden'>
                {me.fullname}
              </span>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default HomeTopBar;
